import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { partnerWorkspaceApi } from "./partnerWorkspaceApi";
import "./partnerWorkspace.css";

const ERROR_COPY = {
  missing_token: "That link looks incomplete. Request a new one below.",
  invalid_or_expired: "That link has expired or was already used. Request a new one below.",
};

export default function PartnerWorkspaceLogin() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get("error");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    try {
      await partnerWorkspaceApi.requestLink(email.trim());
      setSent(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="pw-theme min-h-screen flex items-center justify-center px-6" data-testid="partner-workspace-login-page">
      <div className="w-full max-w-[420px] pw-enter">
        <div className="flex justify-center mb-10">
          <Logo theme="light" size="lg" />
        </div>
        <div className="pw-card p-8">
          <span className="pw-eyebrow">Partner Workspace</span>
          <h1 className="pw-display text-[30px] mt-2 mb-6">Sign in</h1>

          {errorCode && !sent && (
            <div className="mb-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="partner-workspace-login-error">
              {ERROR_COPY[errorCode] || "Something went wrong. Please try again."}
            </div>
          )}

          {sent ? (
            <div data-testid="partner-workspace-login-sent" className="pw-enter">
              <p className="text-[15px] leading-relaxed" style={{ color: "var(--pw-text-secondary)" }}>
                If that email is linked to an active NJM production partner, a sign-in link is on its way — check your inbox. It's valid for 15 minutes and works once.
              </p>
              <button onClick={() => setSent(false)} data-testid="partner-workspace-login-resend-btn" className="pw-btn-secondary mt-6 px-4 py-2 text-sm">
                Use a different email
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label htmlFor="pw-email" className="pw-eyebrow block mb-2">Work email</label>
                <input
                  id="pw-email" type="email" required autoFocus value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@yourcompany.com"
                  data-testid="partner-workspace-login-email-input"
                  className="pw-input w-full px-4 py-3 text-[15px]"
                />
              </div>
              <button type="submit" disabled={sending} data-testid="partner-workspace-login-submit-btn" className="pw-btn-primary w-full py-3 text-sm">
                {sending ? "Sending…" : "Send me a sign-in link"}
              </button>
              <p className="text-xs text-center pt-1" style={{ color: "var(--pw-text-faint)" }}>No password needed — we'll email you a secure link.</p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
